"use strict";
/**
 *
 *
 *
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var uniq_1 = __importDefault(require("lodash/uniq"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var Retainable_1 = require("./Retainable");
var Observable = /** @class */ (function (_super) {
    __extends(Observable, _super);
    function Observable() {
        var _this = _super.call(this) || this;
        _this._listeners = {};
        return _this;
    }
    Observable.prototype._notify = function (event, arg) {
        var _this = this;
        if (event in this._listeners) {
            var eListeners = this._listeners[event].slice(0); // copy in case of listener modifications
            eListeners.forEach(function (listener) {
                if (!_this._listeners) {
                    debugger;
                }
                if (_this._listeners[event].indexOf(listener) !== -1) {
                    // check if listener was removed during update
                    try {
                        listener(arg);
                    }
                    catch (err) {
                        console.log("[Observer] Error notifying listener of event \"" + event + "\"");
                        console.log(err);
                    }
                }
            });
        }
    };
    Observable.prototype.subscribe = function (event, listener) {
        var _this = this;
        if (!listener) {
            // allow null to be passes
            return { dispose: function () { return null; } };
        }
        if (!(event in this._listeners)) {
            this._listeners[event] = [];
        }
        this._listeners[event].push(listener);
        var dispose = function () {
            if (!_this._listeners) {
                console.warn('[Observer] Call dispose an Observable: already destroyed');
                debugger;
                return;
            }
            var listeners = _this._listeners[event];
            var idx = listeners.indexOf(listener);
            if (idx !== -1) {
                listeners.splice(idx, 1);
            }
            else {
                console.warn('Call dispose an Observable: No such listener');
            }
        };
        return { dispose: dispose };
    };
    Observable.prototype.unsubscribe = function (listener) {
        if (!listener) {
            // allow null to be passes
            return false;
        }
        var result = false;
        for (var event_1 in this._listeners) {
            var listeners = this._listeners[event_1];
            var idx = listeners.indexOf(listener);
            if (idx !== -1) {
                listeners.splice(idx, 1);
                result = true;
            }
        }
        return result;
    };
    Observable.prototype.once = function (event, listener) {
        var subscription;
        subscription = this.subscribe(event, function (arg) {
            try {
                listener(arg);
            }
            finally {
                subscription.dispose();
                subscription = null;
            }
        });
        return subscription;
    };
    /**
     * Wait the observer to signal specified event
     *
     * usage:
     *     eventData = await observer.happens('custom-event');
     *     observer.happens('custom-event').then((eventData) => ...);
     *
     * @param {string} event
     * @returns {Promise<any>}
     */
    Observable.prototype.happens = function (event) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.once(event, resolve);
        });
    };
    Observable.prototype._dispose = function () {
        if (this._listeners === null) {
            // might be disposed
            debugger;
        }
        this._listeners = null;
    };
    return Observable;
}(Retainable_1.Retainable));
exports.Observable = Observable;
var ObservableHashSubscription = /** @class */ (function () {
    function ObservableHashSubscription(keys, callback) {
        this._keys = keys;
        this._callback = callback;
    }
    ObservableHashSubscription.prototype.notify = function (model, prev) {
        var args = this._keys.map(function (key) {
            return key === 'update' ? model : model[key];
        });
        try {
            this._callback.apply(window, args);
        }
        catch (err) {
            console.error('ObservableHashSubscription: notify error: ', err);
            console.error(err.stack);
        }
    };
    return ObservableHashSubscription;
}());
var ObservableHash = /** @class */ (function (_super) {
    __extends(ObservableHash, _super);
    function ObservableHash(model, keys) {
        if (keys === void 0) { keys = null; }
        var _this = _super.call(this) || this;
        _this._subscriptionIdsByKey = {};
        _this._subscriptionsByUid = {};
        _this._uid = 0;
        _this._model = model || {};
        _this._keys = keys;
        return _this;
    }
    ObservableHash.prototype.setModel = function (model) {
        var _this = this;
        var prev = this._model;
        this._model = model;
        var changedKeys = this._extractChangedKeys(model, prev);
        changedKeys.push('update'); // always notify 'update'
        var subscriptionIdsToNotify = [];
        changedKeys.forEach(function (key) {
            if (key in _this._subscriptionIdsByKey) {
                // has subscriptions for key
                subscriptionIdsToNotify = subscriptionIdsToNotify.concat(_this._subscriptionIdsByKey[key]); // add them to list
            }
        });
        subscriptionIdsToNotify = uniq_1["default"](subscriptionIdsToNotify);
        subscriptionIdsToNotify.forEach(function (uid) {
            try {
                if (_this._subscriptionsByUid[uid]) {
                    _this._subscriptionsByUid[uid].notify(model, prev);
                }
                else {
                    // the subscription was removed from other callback
                    // warn
                }
            }
            catch (err) {
                console.error(err);
            }
        });
    };
    ObservableHash.prototype.subscribe = function (aKeys, callback) {
        var _this = this;
        var keys = typeof aKeys === 'string' ? aKeys.split(' ') : aKeys;
        var uid = String(this._uid++);
        this._subscriptionsByUid[uid] = new ObservableHashSubscription(keys, callback);
        // register
        keys.forEach(function (key) {
            if (!(key in _this._subscriptionIdsByKey)) {
                _this._subscriptionIdsByKey[key] = [];
            }
            _this._subscriptionIdsByKey[key].push(uid);
        });
        return {
            dispose: function () {
                keys.forEach(function (key) {
                    var uids = _this._subscriptionIdsByKey[key];
                    var idx = uids.indexOf(uid);
                    if (idx !== -1) {
                        uids.splice(idx, 1);
                    }
                    delete _this._subscriptionsByUid[uid];
                });
            }
        };
    };
    ObservableHash.prototype._extractChangedKeys = function (state, prev) {
        var changedKeys = [];
        var allKeys = this._keys;
        if (!allKeys) {
            allKeys = uniq_1["default"](Object.keys(state).concat(Object.keys(prev)));
        }
        for (var _i = 0, _a = allKeys; _i < _a.length; _i++) {
            var key = _a[_i];
            if (!isEqual_1["default"](state[key], prev[key])) {
                changedKeys.push(key);
            }
        }
        return changedKeys;
    };
    ObservableHash.prototype._dispose = function () {
        this._subscriptionIdsByKey = null;
        this._subscriptionsByUid = null;
    };
    return ObservableHash;
}(Retainable_1.Retainable));
exports.ObservableHash = ObservableHash;
